import classNames from "classnames";
import React from "react";
import { MinusIcon, PlusIcon } from "../Icons";
import "./incrementerButton.scss";
import { getWindow } from "../../utils";

enum IncrementerSize {
    "small",
    "medium",
}

export type TIncrementerButton = {
    type?: "increment" | "decrement";
    incrementerSize?: keyof typeof IncrementerSize;
    disabled?: boolean;
    ariaLabel?: string;
    onClick?: () => void;
};

export const IncrementerButton = ({
    type = "increment",
    incrementerSize = "medium",
    disabled = false,
    ariaLabel,
    onClick,
}: TIncrementerButton) => {
    const increment = type === "increment";
    const SmallSize = incrementerSize === "small" ? 14 : 22;

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter") {
            onClick?.();
        }
    };

    const getAriaLabel = () => {
        if (ariaLabel) {
            return ariaLabel;
        }

        if (increment) {
            if (getWindow().__TEXTS__?.["increment"]) {
                return getWindow().__TEXTS__?.["increment"];
            }

            return "Increment";
        } else {
            if (getWindow().__TEXTS__?.["decrement"]) {
                return getWindow().__TEXTS__?.["decrement"];
            }

            return "Decrement";
        }
    };

    return (
        <div
            role="button"
            title={getAriaLabel()}
            className={classNames("c-incrementer-button", {
                "c-incrementer-button--disabled": disabled,
            })}
            style={{ padding: SmallSize && SmallSize / 3 }}
            aria-label={getAriaLabel()}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            tabIndex={0}
        >
            {increment ? (
                <PlusIcon {...{ size: incrementerSize === "small" ? SmallSize : undefined }} />
            ) : (
                <MinusIcon {...{ size: incrementerSize === "small" ? SmallSize : undefined }} />
            )}
        </div>
    );
};

export default IncrementerButton;
